class ProductCard {
  constructor(node, ratingData, netflixBadgeUrl = '', collectionInternationalDiscount = false) {
    this.product = node;
    this.ratingAvg = ratingData.avg;
    this.netflixBadgeUrl = netflixBadgeUrl;
    this.collection2x = ['go-cook-sweepstakes-2025-2x-entries'];
    this.collection3x = ['go-cook-sweepstakes-2025-3x-entries'];
    this.collection4x = ['go-cook-sweepstakes-2025-4x-entries'];
    this.isSweepstakes = false;
    this.collectionInternationalDiscount = collectionInternationalDiscount;
  }

  renderStars() {
    if (this.ratingAvg <= 3.0) return ''; 

    return `
      <div class="opinew-stars-plugin-product-list opinew-style">
        <div class="opinew_review_stars">
          <svg width="8" height="8" viewBox="0 0 8 8" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M3.75928 0.5L4.84186 2.80676L7.26319 3.17677L5.51104 4.97229L5.92485 7.50782L3.75928 6.31067L1.59372 7.50782L2.00753 4.97229L0.255371 3.17677L2.6767 2.80676L3.75928 0.5Z" fill="#FFB900"/>
          </svg>
        </div>
        <div class="opinew_review_stars_rate">${this.ratingAvg.toFixed(1)}</div>
      </div>
    `;
  }
  
  getSaleInfo(productPrice, productCollections) {
    let scriptSale = false;
    let scriptSavedAmount = null;

    const price = parseFloat(productPrice);
    if (isNaN(price)) return { scriptSale, scriptSavedAmount };
  
    // Define discount mappings
    const discountMapping = {
      "Cookware | 50%OFF": 0.5,
      "50%": 0.5,
      "60%": 0.6,
      "70%": 0.7,
      "65%": 0.65,
      "55%": 0.55,
      "45%": 0.45,
      "40%": 0.4,
      "30%": 0.3,
      "25%": 0.25,
      "20%": 0.2,
      "15%": 0.15,
      "10%": 0.1,
      "14%": 0.14285,
      "16%": 0.16667,
      "13%": 0.130438,
      "7.5%": 0.075,
      "20.833%" : 0.20833,
      "19%" : 0.19093,
      "33.44%": 0.33445,
      "12.53%": 0.12531,
      "21.83%": 0.21834,
      "26.385%" : 0.26385,
      "25.126%": 0.251256,
      "28.571%": 0.28571,
      "20.067%": 0.20067,
      "20.080%": 0.20080,
      "5%": 0.05
    };
  
    // Get selected countries from Settings
    const selectedCountry = window.themeSettings?.promotionCountry;
    const userCountry = localStorage.getItem('userCountry');
      
    // Store the selected country from settings
    console.log("county from :", selectedCountry);

    const isSelectedCountry = selectedCountry === userCountry;
  
    // Check if collection has international_discount metafield set to true
    const hasCountryDiscount = this.collectionInternationalDiscount;

    // Apply discount only if conditions are met
    if (hasCountryDiscount && isSelectedCountry) {
      for (const collection of productCollections) {
        for (const [key, discount] of Object.entries(discountMapping)) {
          if (collection.includes(key)) {
            scriptSavedAmount = price * discount;
            scriptSale = true;
            return { scriptSale, scriptSavedAmount }; // Stop looping once a match is found
          }
        }
      }
    } else if (!hasCountryDiscount) {
      // Apply discount logic for all other cases (no international_discount metafield)
      for (const collection of productCollections) {
        for (const [key, discount] of Object.entries(discountMapping)) {
          if (collection.includes(key)) {
            scriptSavedAmount = price * discount;
            scriptSale = true;
            return { scriptSale, scriptSavedAmount }; // Stop looping once a match is found
          }
        }
      }
    } 
  
    return { scriptSale, scriptSavedAmount };
  }

  getPointsInfo(price, scriptSavedAmount, productCollections) {
    const discountedPrice = scriptSavedAmount ? price - scriptSavedAmount : price;
    let points = Math.round(discountedPrice);

    const handles = productCollections.map(edge => edge.node.handle);
    let multiplier = 1;

    const body = document.body;

    if (body.classList.contains('body--sweepstakes__bonus')) {
      multiplier = 2;
      this.isSweepstakes = true;
    } else if (body.classList.contains('body--sweepstakes__bonus_3x')) {
      multiplier = 3;
      this.isSweepstakes = true;
    }

    if (handles.some(handle => this.collection4x.includes(handle)) && multiplier < 4) {
      multiplier = 4;
    } else if (handles.some(handle => this.collection3x.includes(handle)) && multiplier < 3) {
      multiplier = 3;
    } else if (handles.some(handle => this.collection2x.includes(handle)) && multiplier < 2) {
      multiplier = 2;
    }

    points = Math.floor(points * multiplier);
    return { points, multiplier, handles };
  }

  getCountdownTimer() {
    // Get current time in EST
    const now = new Date();
    const estTime = new Date(now.toLocaleString('en-US', { timeZone: 'America/New_York' }));
    
    // Set end of day in EST (11:59:59 PM)
    const endOfDay = new Date(estTime);
    endOfDay.setHours(23, 59, 59, 999);
    
    // Calculate difference in milliseconds
    const diff = endOfDay - estTime;
    
    if (diff <= 0) {
      return '00:00:00';
    }
    
    // Calculate hours, minutes, seconds
    const hours = Math.floor(diff / (1000 * 60 * 60));
    const minutes = Math.floor((diff % (1000 * 60 * 60)) / (1000 * 60));
    const seconds = Math.floor((diff % (1000 * 60)) / 1000);
    
    // Format with leading zeros
    return `${String(hours).padStart(2, '0')}:${String(minutes).padStart(2, '0')}:${String(seconds).padStart(2, '0')}`;
  }


  startCountdown(timerElement) {
    const updateTimer = () => {
      timerElement.textContent = this.getCountdownTimer();
    };
    
    // Update every second
    setInterval(updateTimer, 1000);
  }

  render() {
    const title = this.product.title || '';
    const parts = title.split(' | ');

    const productName = parts[0];
    const series = parts.find(part =>
      /series|edition/i.test(part)
    ) || parts.find(part => part.includes('Dalstrong')) || '';
    const collections = this.product.collections?.edges?.map(edge => edge.node) || [];
    const normalizedSeries = series.trim()
    let matchingCollection = collections.find(
      col => col.title?.trim() === normalizedSeries
    );

    if (!matchingCollection) {
      matchingCollection = collections.find(
        col => normalizedSeries.toLowerCase().includes(col.title?.toLowerCase())
      );
    }
    
    const collectionSpecs = this.product.featuresBenefits?.value || matchingCollection?.metafield?.value || '';
    const collectionSpecsShort = this.product.materials?.value || matchingCollection?.mobileSpecs?.value || '';
    const variantId = this.product.variants.edges[0].node.id.split('/').pop();
    
    // Get image from metafields or fallback to featured image
    let imageUrl = '';
    const cardImageUrl = this.product.productCardImage?.reference?.image?.url;
    if (cardImageUrl) {
      imageUrl = cardImageUrl;
    } else {
      imageUrl = this.product.metafield?.reference?.image?.url || this.product.featuredImage?.url || this.product.images?.edges[0]?.node.url || '';
    }

    const price = parseFloat(this.product.priceRange.minVariantPrice.amount);
    const compareAtPrice = parseFloat(this.product.compareAtPriceRange.maxVariantPrice.amount);
    const currency = this.product.priceRange.minVariantPrice.currencyCode;
    const isSoldOut = !this.product.availableForSale;
    const isPreOrder = this.product.tags.includes('pre-order');
    const isNew = this.product.tags.includes('new');
    const hasBundleSave = this.product.tags.includes('pcs_block') || this.product.tags.includes('individual_pcs');
    const isBestSeller = this.product.tags.includes('BEST_SELLER');
    const hasBonusSheath = this.product.tags.includes('abs_sheath') || this.product.tags.includes('nylon_sheath') || this.product.tags.includes('leather_sheath') || this.product.tags.includes('wood_sheath') || this.product.tags.includes('bonus_sheath');
    const isNetflixBadge = this.product.tags.includes('Netflix_badge');
    const isBfcmDeal = this.product.tags.includes('bfcm-daily-deal');
    
    // Get collection titles for sale info
    const collectionTitles = this.product.collections.edges.map(edge => edge.node.title);
    
    const { scriptSale, scriptSavedAmount } = this.getSaleInfo(price, collectionTitles);
    const isLimitedTimeDeal = scriptSale;
    const discountPercentage = scriptSale ? Math.round((scriptSavedAmount / price) * 100) : 0;
    const hasCompareAtPrice = compareAtPrice > price;
    const finalPrice = scriptSale ? (price - scriptSavedAmount) : price;
    const { points, multiplier } = this.getPointsInfo(price, scriptSavedAmount, this.product.collections.edges);

    let pointsBadgeHtml = '';
    if (multiplier > 1 && this.product.availableForSale) {
      const productTags = this.product.tags;
      const bestSeller = productTags.includes('BEST_SELLER');
      const isBatmanKnife = productTags.includes('Batman series') && productTags.includes('knife');
      const isNetflix = productTags.includes('Netflix_badge');
      const hasSheath = productTags.some(tag =>
        ['abs_sheath','nylon_sheath','wood_sheath','leather_sheath'].includes(tag)
      );

      let extraClasses = '';
      if (isBatmanKnife) extraClasses += ' badge--points__batman';
      if (isNetflix)    extraClasses += ' badge--points__netflix';
      if (!scriptSale && !bestSeller && !isNew && !hasSheath) {
        extraClasses += ' badge--points__single';
      }

      pointsBadgeHtml = `
        <span class="badge--new grid-product__tag--points${extraClasses}">
          ${points} entries
        </span>
      `;
    }

    const hasSweepstakesCollection = collections.find(
      c => c.title && c.title.toLowerCase().includes('sweepstakes')
    );

    const productCard = document.createElement('div');
    productCard.className = 'grid__item';
    productCard.classList.add('new-card');
    productCard.innerHTML = `
      <div class="grid-product__content ${isBfcmDeal ? ' bfcm-daily' : ''}">
        <div class="badge-overlay${this.isSweepstakes ? ' hide' : ''}">
          ${isPreOrder && !isSoldOut ? '<div class="badge--new grid-product__tag--pre-order">PRE ORDER</div>' : ''}
          ${isLimitedTimeDeal && !isPreOrder && !isSoldOut ? '<div class="badge--new grid-product__tag--limited-time-deal">LIMITED TIME DEAL</div>' : ''}
          ${isNew && !isPreOrder && !isLimitedTimeDeal && !isSoldOut && !isNetflixBadge ? '<div class="badge--new grid-product__tag--new">NEW</div>' : ''}
          ${hasBundleSave && !isPreOrder && !isLimitedTimeDeal && !isNew && !isSoldOut && !isNetflixBadge ? '<div class="badge--new grid-product__tag--bundle-and-save">Bundle & Save</div>' : ''}
          ${isBestSeller && !isPreOrder && !isLimitedTimeDeal && !isNew && !hasBundleSave && !isSoldOut && !isNetflixBadge ? '<div class="badge--new grid-product__tag--best-seller">BEST SELLER</div>' : ''}
          ${isSoldOut ? '<div class="badge--new grid-product__tag--sold-out">SOLD OUT</div>' : ''}
        </div>
        ${isNetflixBadge && !isLimitedTimeDeal ? `<img src="${this.netflixBadgeUrl}" alt="Netflix badge" loading="lazy" class="badge--netflix">` : ''}
        ${isBfcmDeal && !isSoldOut ? '<div class="badge--daily-deal">🔥 Shop today’s daily deaL</div>' : ''}
        <div class="collection-product-wrapper">
          <div class="grid-product__image-mask">
            <a href="${this.product.onlineStoreUrl}">
              <img class="grid-product__image" src="${imageUrl}" alt="${this.product.title}" loading="lazy">
            </a>
          </div>
          <div class="collection-product__info-wrapper">
            <div class="product-container__description">
              <a href="${this.product.onlineStoreUrl}" class="grid-product__link">
                <div class="collection-product__title">
                  <div class="collection-product__collection-title">
                    <div class="collection-product__series-title">${series || ''}</div>
                    ${this.renderStars()}
                  </div>
                  <div class="collection-product__product-title">${productName}</div>
                </div>
                <div class="collection-product__collection-specs">${collectionSpecs}</div>
                <div class="collection-product__collection-specs-short">${collectionSpecsShort}</div>
              </a>
            </div>
            <div class="collection-product__button-container">
              <div class="grid-collection-product__price${scriptSale || hasCompareAtPrice ? ' script-sale-price' : ''}">
                ${scriptSale ? `<span class="home-discount-percentage">-${discountPercentage}%</span>` : ''}
                <span class="igPrice" data-variant-id="${variantId}">${finalPrice.toLocaleString('en-US', { style: 'currency', currency: currency })}</span>
                ${scriptSale ? `<span class="home-card-discount" data-variant-id="${variantId}">${price.toLocaleString('en-US', { style: 'currency', currency: currency }).slice(0, -3)}</span>` : ''}
                ${!scriptSale && hasCompareAtPrice ? `<span class="home-card-discount" data-variant-id="${variantId}">${compareAtPrice.toLocaleString('en-US', { style: 'currency', currency: currency }).slice(0, -3)}</span>` : ''}
                <div class="line-break"></div>
                ${hasBundleSave && !this.isSweepstakes && !scriptSale ? '<div class="badge--new badge--secondary grid-product__tag--best-value">BEST VALUE</div>' : ''}
                ${pointsBadgeHtml}
              </div>
              <div class="collection-product__urgency-line${scriptSale ? ' timer-line' : ''}${hasBundleSave ? ' hidden-line' : ''}">
                ${scriptSale ? (isBfcmDeal ? `<span class="countdown-timer" data-variant-id="${variantId}">${this.getCountdownTimer()}</span> Remaining to End.` : `Limited Time Deal!`) : ''}
                ${hasCompareAtPrice && !scriptSale ? `You Save ${(compareAtPrice - price).toFixed(2)} USD` : ''}
              </div>
            </div>
          </div>
          <button 
            class="add-to-cart btn--full" 
            data-native-pre-order-btn
            data-starting-variant="${variantId}"
            data-variant-id="${variantId}"
            ${isSoldOut ? 'disabled' : ''}
          >
            ${isSoldOut ? 'Sold Out' : 'Add to Cart'}
          </button>
        </div>
      </div>
    `;

    const imageWrapper = productCard.querySelector('.grid-product__image');
    const handles = this.product.collections?.edges?.map(edge => edge.node.handle) || [];
    let extraImageHtml = '';
    if (this.product.availableForSale) {
      const body = document.body;

      let badgeType = '';

      if (body.classList.contains('body--sweepstakes__bonus')) {
        badgeType = '2x';
      } else if (body.classList.contains('body--sweepstakes__bonus_3x')) {
        badgeType = '3x';
      }

      if (handles.some(handle => this.collection4x.includes(handle))) {
        badgeType = '4x';
      } else if (handles.some(handle => this.collection3x.includes(handle)) && badgeType !== '4x') {
        badgeType = '3x';
      } else if (handles.some(handle => this.collection2x.includes(handle)) && !['3x','4x'].includes(badgeType)) {
        badgeType = '2x';
      }

      if (badgeType) {
        const badgeMap = {
          '2x': 'https://cdn.shopify.com/s/files/1/1728/9189/files/Frame_5292.png?v=1759255810',
          '3x': 'https://cdn.shopify.com/s/files/1/1728/9189/files/3X_Entries.png?v=1759262822',
          '4x': 'https://cdn.shopify.com/s/files/1/1728/9189/files/4X_Entries.png?v=1759262822'
        };
        extraImageHtml = `<img class="extra-badge" src="${badgeMap[badgeType]}" alt="${badgeType} Entries" loading="lazy">`;
      }
    }

    if (imageWrapper && extraImageHtml) {
      imageWrapper.insertAdjacentHTML('afterend', extraImageHtml);
    }
    
    const addToCartButton = productCard.querySelector('.add-to-cart');
    if (addToCartButton && !isSoldOut) {
      addToCartButton.addEventListener('click', (event) => {
        event.preventDefault();
        event.stopPropagation();
        
        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            items: [{
              id: variantId,
              quantity: 1
            }]
          })
        })
        .then(response => response.json())
        .then(data => {
          document.dispatchEvent(new CustomEvent('cart:build'));
        })
        .then(() => {
          document.querySelector('.js-drawer-open-cart').click();
        })
        .catch(error => {
          console.error('Error adding item to cart:', error);
        });
      });
    }

     // Initialize countdown timer if product has bf-bundle tag and is on sale
    if (scriptSale && isBfcmDeal) {
      const timerElement = productCard.querySelector('.countdown-timer');
      if (timerElement) {
        this.startCountdown(timerElement);
      }
    }

    return productCard;
  }
}

class CollectionGridNew extends HTMLElement {
  constructor() {
    super();
    this.swiper = null;
    this.isLoading = false;
    this.defaultCollectionHandle = this.dataset.defaultCollectionHandle;
    this.slides = this.querySelectorAll('.collection-grid-new__slide');
    this.optionPicker = this.querySelector('.option-picker');
    this.optionPickerBtn = this.querySelector('.option-picker-btn');
    this.optionPickerList = this.querySelector('.option-picker-list');
    this.defaultFilterTypes = this.dataset.filter;
    this.currentFilterTypes = {};
    this.selectedOptions = [];
    this.customCardsIndexes = [0, 7, 9, 14, 16, 21, 27, 29, 32];
    this.customCards = [];
    this.customCardsData = [];
    this.activeCollectionHandle = this.defaultCollectionHandle;
    this.dalstrongLoaderElement = `
      <div class="collection-grid-new-loading-bg">
        <div class="animating-logo-wrapper" data-image-src="${ this.dataset.loaderImageUrl }"></div>
      </div>
    `;
    this.pageSize = 52;
    this.filteredProducts = [];
    this.currentPage = 1;
    this.opinewRatings = this.parseOpinewRatings();
    this.netflixBadgeUrl = this.dataset.netflixBadge;
    this.collection2x = ['go-cook-sweepstakes-2025-2x-entries'];
    this.collection3x = ['go-cook-sweepstakes-2025-3x-entries'];
    this.collection4x = ['go-cook-sweepstakes-2025-4x-entries'];
    this.collectionInternationalDiscount = false;
  }

  connectedCallback() {
    this.initSwiper();
    this.setupEventListeners();
    this.fetchCollectionProducts();
  }

  setupEventListeners() {
    this.slides.forEach(slide => {
      slide.addEventListener('click', (e) => {
        if (e.currentTarget.classList.contains('active')) return;

        this.slides.forEach(s => s.classList.remove('active'));
        slide.classList.add('active');
        // Clear filter types and selected options when switching tabs
        this.optionPickerList.innerHTML = '';
        this.selectedOptions = [];
        this.fetchCollectionProducts();
      });
    });

    // Add click outside handler
    this.addEventListener('click', (event) => {
      const listContainer = this.querySelector('.option-picker-list-container');
      const isClickInsideList = listContainer?.contains(event.target);
      const isClickOnButton = this.optionPickerBtn.contains(event.target);

      if (isClickOnButton && !this.optionPicker.classList.contains('active')) {
        return this.optionPicker.classList.add('active');
      }
      
      if (
        event.target.closest('.option-picker-close') ||
        (!isClickInsideList && !isClickOnButton && this.optionPicker.classList.contains('active'))
      ) {
        this.optionPicker.classList.remove('active');
      }
    });

    this.optionPickerList.addEventListener('click', (event) => {
      const item = event.target.closest('.option-picker-list-sub-item');
      if (item) {
        event.preventDefault();
        event.stopPropagation();
        const checkbox = item.querySelector('.custom-checkbox');
        checkbox.classList.toggle('checked');
        this.updateSelectedOptions(item);
      }
    });
  }

  getSaleInfo(productPrice, productCollections) {
    let scriptSale = false;
    let scriptSavedAmount = null;

    const price = parseFloat(productPrice);
    if (isNaN(price)) return { scriptSale, scriptSavedAmount };
  
    // Define discount mappings
    const discountMapping = {
      "Cookware | 50%OFF": 0.5,
      "50%": 0.5,
      "60%": 0.6,
      "70%": 0.7,
      "65%": 0.65,
      "55%": 0.55,
      "45%": 0.45,
      "40%": 0.4,
      "30%": 0.3,
      "25%": 0.25,
      "20%": 0.2,
      "15%": 0.15,
      "10%": 0.1,
      "14%": 0.14285,
      "16%": 0.16667,
      "13%": 0.130438,
      "7.5%": 0.075,
      "33.44%": 0.33445,
      "20.833%" : 0.20833,
      "19%" : 0.19093,
      "12.53%": 0.12531,
      "21.83%": 0.21834,
      "26.385%" : 0.26385,
      "25.126%": 0.251256,
      "28.571%": 0.28571,
      "20.067%": 0.20067,
      "20.080%": 0.20080,
      "5%": 0.05
    };

    // Get selected countries from Settings
    const selectedCountry = window.themeSettings?.promotionCountry;
    const userCountry = localStorage.getItem('userCountry');
      
    console.log("county from :", selectedCountry);

    const isSelectedCountry = selectedCountry === userCountry;

    // Check if collection has international_discount metafield set to true
    const hasCountryDiscount = this.collectionInternationalDiscount;

    // Apply discount only if conditions are met
    if (hasCountryDiscount && isSelectedCountry) {
      for (const collection of productCollections) {
        for (const [key, discount] of Object.entries(discountMapping)) {
          if (collection.includes(key)) {
            scriptSavedAmount = price * discount;
            scriptSale = true;
            return { scriptSale, scriptSavedAmount };
          }
        }
      }
    } else if (!hasCountryDiscount) {
      // Apply discount logic for all other cases
      for (const collection of productCollections) {
        for (const [key, discount] of Object.entries(discountMapping)) {
          if (collection.includes(key)) {
            scriptSavedAmount = price * discount;
            scriptSale = true;
            return { scriptSale, scriptSavedAmount };
          }
        }
      }
    }
  
    return { scriptSale, scriptSavedAmount };
  }

  getPointsInfo(price, scriptSavedAmount, productCollections) {
    const discountedPrice = scriptSavedAmount ? price - scriptSavedAmount : price;
    let points = Math.round(discountedPrice);

    const handles = productCollections.map(edge => edge.node.handle);
    let multiplier = 1;

    const body = document.body;

    if (body.classList.contains('body--sweepstakes__bonus')) {
      multiplier = 2;
    } else if (body.classList.contains('body--sweepstakes__bonus_3x')) {
      multiplier = 3;
    }

    if (handles.some(handle => this.collection4x.includes(handle)) && multiplier < 4) {
      multiplier = 4;
    } else if (handles.some(handle => this.collection3x.includes(handle)) && multiplier < 3) {
      multiplier = 3;
    } else if (handles.some(handle => this.collection2x.includes(handle)) && multiplier < 2) {
      multiplier = 2;
    }

    points = Math.floor(points * multiplier);
    return { points, multiplier, handles };
  }

  parseOpinewRatings() {
    const ratingsJson = document.getElementById('opinew-ratings-json');
    if (ratingsJson) {
      try {
        return JSON.parse(ratingsJson.textContent);
      } catch (e) {
        console.error('Failed to parse Opinew ratings JSON:', e);
      }
    }
    return {};
  }

  renderProducts(products, append = false) {
    let productGrid = this.querySelector('.product-grid');
    if (!productGrid) {
      productGrid = document.createElement('div');
      productGrid.className = 'product-grid';
      const optionPicker = this.querySelector('.option-picker');
      if (optionPicker) {
        optionPicker.after(productGrid);
      } else {
        this.appendChild(productGrid);
      }
    }
    
    if (!append) {
      productGrid.innerHTML = '';
    }

    // Update collection info
    const activeSlide = this.querySelector('.collection-grid-new__slide.active');
    const collectionTitle = activeSlide?.querySelector('.collection-grid-new__subtitle')?.textContent?.trim() || '';
    const collectionTitleElement = this.querySelector('.collection-title');
    const collectionCounterElement = this.querySelector('.collection-counter');
    
    if (collectionTitleElement) {
      collectionTitleElement.textContent = collectionTitle;
    }

    // Add loading element to product grid
    productGrid.insertAdjacentHTML('beforeend', this.dalstrongLoaderElement);
    this.dalstrongLoader = productGrid.querySelector('.collection-grid-new-loading-bg');

    // Show loading element before rendering products
    if (this.dalstrongLoader) {
      this.dalstrongLoader.classList.add('active');
      const logoWrapper = this.dalstrongLoader.querySelector('.animating-logo-wrapper');
      if (logoWrapper) {
        logoWrapper.insertAdjacentHTML('beforeend', `
          <img 
            src="${logoWrapper.dataset.imageSrc}"
            alt="Animated logo loader"
            width="100"
            height="88"
          />
        `);
      }
    }

    products.forEach(({ node }, index) => {
      // Insert custom card if this index matches
      if (this.customCardsIndexes.includes(index) && this.customCards.length > 0) {
        const customCard = this.customCards.shift();
        if (customCard) {
          productGrid.insertBefore(customCard, productGrid.children[index]);
        }
      }
      const netflixBadgeUrl = this.dataset.netflixBadge;
      const ratingData = this.opinewRatings?.[node.handle] || { avg: 0 };

      const productCard = new ProductCard(node, ratingData, this.netflixBadgeUrl, this.collectionInternationalDiscount);
      productGrid.appendChild(productCard.render());
    });
    
    // Update the counter after all products are appended
    if (collectionCounterElement) {
      collectionCounterElement.textContent = `(${this.filteredProducts.length} results)`;
    }

    // Remove loading element after products are rendered
    setTimeout(() => {
      if (this.dalstrongLoader) {
        this.dalstrongLoader.classList.remove('active');
        const logoWrapper = this.dalstrongLoader.querySelector('.animating-logo-wrapper');
        if (logoWrapper) {
          logoWrapper.innerHTML = '';
        }
      }
    }, 500);
  }

  prepareCustomProductCardsData(cards) {
    // Store raw data for regeneration
    this.customCardsData = cards || [];
    this.generateCustomCards(this.customCardsData);
  }

  generateCustomCards(cardData) {
    this.customCards = [];
    if (!cardData?.length) {
      return;
    }
    cardData.forEach((card, index) => {
      if (!card || !card.fields) {
        return;
      }
      // Find the product field in the metaobject
      const productField = card.fields.find(field => field.key === 'product');
      if (!productField?.reference) {
        return;
      }
      // Find the media file field in the metaobject
      const mediaField = card.fields.find(field => field.key === 'media_file');
      let imageUrl = '';
      if (mediaField?.reference?.image?.url) {
        imageUrl = mediaField.reference.image.url;
      } else {
        // Fallback to product's featured image
        imageUrl = productField.reference.featuredImage?.url || '';
      }
      const descriptionField = card.fields.find(field => field.key === 'description');
      const description = descriptionField?.value || '';
      const product = productField.reference;
      const title = product.title || '';
      const parts = title.split(' | ');
      const productName = parts[0];
      const series = parts.find(part =>
        /series|edition/i.test(part)
      ) || parts.find(part => part.includes('Dalstrong')) || '';
      const variantId = product.variants.edges[0].node.id.split('/').pop();
      const cardElement = document.createElement('div');
      const isWideCard = card.fields.find(field => field.key === 'width_2x')?.value === 'true';
      
      cardElement.className = index === 0 && isWideCard ? 'grid__item custom-product-card width-2x' : 'grid__item custom-product-card';
      let cardHTML = index === 0 && isWideCard ? 
      `
        <div class="custom-product-card-image-container">
          <img class="custom-product-card-image" src="${imageUrl}" alt="${product.title}" loading="lazy">
        </div>
        <p class="custom-product-card-description">${description.split('\n').map(line => `<span>${line}</span><br>`).join('')}</p>
        <div class="custom-product-card-content desktop">
          <div class="custom-product-card-content-image-container">
            <img class="custom-product-card-content-image" src="${product.metafield?.reference?.image?.url || ''}" alt="${product.title}">
          </div>
          <div class="custom-product-card-content-text-container">
            <p class="custom-product-card-series-title">${series || ''}</p>
            <p class="custom-product-card-title">${productName}</p>
            <button class="custom-product-card-button" data-variant-id="${variantId}">ADD TO CART</button>
          </div>
        </div>
        <div class="custom-product-card-content mobile">
          <div class="custom-product-card-content-text-container">
            <div class="custom-product-card-titles-container">
              <p class="custom-product-card-series-title">${series || ''}</p>
              <p class="custom-product-card-title">${productName}</p>
            </div>
            <button class="custom-product-card-button" data-variant-id="${variantId}">ADD TO CART</button>
          </div>
        </div>
      `
      :
      `
        <div class="custom-product-card-image-container">
          <img class="custom-product-card-image" src="${imageUrl}" alt="${product.title}" loading="lazy">
        </div>
        <div class="custom-product-card-content">
          <p class="custom-product-card-series-title">${series || ''}</p>
          <p class="custom-product-card-title">${productName}</p>
        </div>
        <div class="custom-product-card-button-wrapper">
          <button class="custom-product-card-button" data-variant-id="${variantId}">ADD TO CART</button>
        </div>
      `;
      cardElement.innerHTML = cardHTML;
      // Add event listener to the add to cart button
      const addToCartButton = cardElement.querySelector('.custom-product-card-button');
      if (addToCartButton) {
        addToCartButton.addEventListener('click', (event) => {
          event.preventDefault();
          event.stopPropagation();
          fetch('/cart/add.js', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
            },
            body: JSON.stringify({
              items: [{
                id: variantId,
                quantity: 1
              }]
            })
          })
          .then(response => response.json())
          .then(data => {
            document.dispatchEvent(new CustomEvent('cart:build'));
          })
          .then(() => {
            document.querySelector('.js-drawer-open-cart').click();
          })
          .catch(error => {
            console.error('Error adding item to cart:', error);
          });
        });
      }
      this.customCards.push(cardElement);
    });
  }

  getCountry() {
    const path = window.location.pathname.toLowerCase();
  
    if (path.startsWith('/en-gb')) return 'GB';
    if (path.startsWith('/en-aunz')) return 'AU';
    if (path.startsWith('/en-eu')) return 'DE';
  
    return 'US';
  }

  async fetchCollectionProducts() {
    if (this.slides) {
      this.slides.forEach(slide => {
        if (slide.classList.contains('active')) {
          this.activeCollectionHandle = slide.dataset.subcollectionHandle;
        }
      });
    }
  
    const query = `
      query getCollectionWithProducts(
        $handle: String!
        $cursor: String
        $country: CountryCode
        ) @inContext(country: $country) {
        collection(handle: $handle) {
          id
          title
          description
          internationalDiscount: metafield(namespace: "custom", key: "international_discount") {
            value
            type
          }
          metafield(namespace: "custom", key: "filter_types") {
            value
            references(first: 50) {
              nodes {
                ... on Metaobject {
                  fields {
                    key
                    value
                  }
                }
              }
            }
          }
          customProductCards: metafield(namespace: "custom", key: "custom_card_products") {
            value
            references(first: 50) {
              nodes {
                ... on Metaobject {
                  id
                  type
                  fields {
                    key
                    value
                    reference {
                      ... on Product {
                        id
                        title
                        handle
                        onlineStoreUrl
                        availableForSale
                        featuredImage {
                          url
                          altText
                        }
                        metafield(namespace: "img", key: "card_image") {
                          value
                          reference {
                            ... on MediaImage {
                              image {
                                url
                                altText
                              }
                            }
                          }
                        }
                        variants(first: 1) {
                          edges {
                            node {
                              id
                            }
                          }
                        }
                        tags
                      }
                      ... on MediaImage {
                        image {
                          url
                          altText
                        }
                      }
                    }
                  }
                }
              }
            }
          }
          products(first: 250, after: $cursor) {
            pageInfo {
              hasNextPage
              endCursor
            }
            edges {
              node {
                id
                title
                handle
                onlineStoreUrl
                availableForSale
                featuredImage {
                  url
                  altText
                }
                metafield(namespace: "img", key: "card_image") {
                  value
                  reference {
                    ... on MediaImage {
                      image {
                        url
                        altText
                      }
                    }
                  }
                }
                productCardImage: metafield(namespace: "custom", key: "product_card_image") {
                  reference {
                    ... on MediaImage {
                      image {
                        url
                      }
                    }
                  }
                }
                featuresBenefits: metafield(namespace: "custom", key: "features_benefits") {
                  value
                }
                materials: metafield(namespace: "custom", key: "materials") {
                  value
                }
                priceRange {
                  minVariantPrice {
                    amount
                    currencyCode
                  }
                }
                compareAtPriceRange {
                  maxVariantPrice {
                    amount
                    currencyCode
                  }
                }
                variants(first: 1) {
                  edges {
                    node {
                      id
                      availableForSale
                      price {
                        amount
                        currencyCode
                      }
                      compareAtPrice {
                        amount
                        currencyCode
                      }
                    }
                  }
                }
                tags
                collections(first: 100) {
                  edges {
                    node {
                      title
                      handle
                      metafield(namespace: "custom", key: "cards_specifications") {
                        value
                      }
                      mobileSpecs: metafield(namespace: "custom", key: "cards_specifications_short") {
                        value
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    `;
  
    let allProductEdges = [];
    let hasNextPage = true;
    let cursor = null;
  
    try {
      while (hasNextPage) {
        const variables = {
          handle: this.activeCollectionHandle,
          cursor,
          country: this.getCountry()
        };
  
        const res = await fetch('https://dalstrong.com/api/2024-01/graphql.json', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'X-Shopify-Storefront-Access-Token': '1b6fb80e9d47a09bf6147e9744d97c2b'
          },
          body: JSON.stringify({ query, variables })
        });
  
        const json = await res.json();
        if (json.errors) {
          console.error('GraphQL Errors:', json.errors);
          return;
        }
  
        const collection = json.data.collection;
        const productData = collection.products;
  
        allProductEdges.push(...productData.edges);
  
        hasNextPage = productData.pageInfo.hasNextPage;
        cursor = productData.pageInfo.endCursor;
        
        // Store collection's international discount setting
        if (collection.internationalDiscount?.value) {
          this.collectionInternationalDiscount = collection.internationalDiscount.value === 'true' || collection.internationalDiscount.value === true;
        } else {
          this.collectionInternationalDiscount = false;
        }
        
        if (collection.metafield?.references?.nodes) {
          this.configureFilterTypes(allProductEdges, collection.metafield);
          this.renderFilterTypes();
        } else {
          if (this.defaultFilterTypes) {
            try {
              const filterTypesData = JSON.parse(this.defaultFilterTypes);
              // Convert section settings format to match metafield format
              const filterTypes = {
                references: {
                  nodes: filterTypesData.map(type => ({
                    fields: [
                      { key: 'title', value: type.title },
                      { key: 'options', value: JSON.stringify(type.options) }
                    ]
                  }))
                }
              };
              this.configureFilterTypes(allProductEdges, filterTypes);
              this.renderFilterTypes();
            } catch (e) {
              console.error('Error parsing filter types from section settings:', e);
              this.optionPickerList.innerHTML = '';
            }
          } else {
            this.optionPickerList.innerHTML = '';
          }
        }
        console.log("collection: ", collection);
        if (collection.customProductCards?.references?.nodes) {
          this.prepareCustomProductCardsData(collection.customProductCards.references.nodes);
        }
      }
  
      // Save to session
      sessionStorage.setItem('allProducts', JSON.stringify(allProductEdges));
  
      // Final rendering
      this.filterAndRenderProducts();
    } catch (error) {
      console.error('Error fetching collection products:', error);
    }
  }  

  configureFilterTypes(collection, metafield) {
    // Get filter types from collection metafield references
    const filterTypeMetaobjects = metafield.references.nodes;
    
    // Reset current filter types
    this.currentFilterTypes = {};
    
    // Configure filter types based on metaobject data
    collection.forEach(product => {
      filterTypeMetaobjects.forEach(metaobject => {
        const titleField = metaobject.fields.find(field => field.key === 'title');
        const optionsField = metaobject.fields.find(field => field.key === 'options');
        
        if (titleField && optionsField) {
          const title = titleField.value;
          const options = JSON.parse(optionsField.value);
          
          options.forEach(option => {
            if (product.node.tags.includes(option)) {
              if (!Array.isArray(this.currentFilterTypes[title])) {
                this.currentFilterTypes[title] = [];
              }
              if (!this.currentFilterTypes[title].includes(option)) {
                this.currentFilterTypes[title].push(option);
              }
            }
          });
        }
      });
    });

    if (this.currentFilterTypes["Knife Length"]) {
      this.currentFilterTypes["Knife Length"].sort((a, b) => {
        return parseFloat(a) - parseFloat(b);
      });
    }
    if (this.currentFilterTypes["Cutting Board Size"]) {
      this.currentFilterTypes["Cutting Board Size"].sort((a, b) => {
        return parseFloat(a) - parseFloat(b);
      });
    }
    if (this.currentFilterTypes["Honing Rod Length"]) {
      this.currentFilterTypes["Honing Rod Length"].sort((a, b) => {
        return parseFloat(a) - parseFloat(b);
      });
    }
    if (this.currentFilterTypes["Grit"]) {
      this.currentFilterTypes["Grit"].sort((a, b) => {
        return parseFloat(a) - parseFloat(b);
      });
    }
  }

  renderFilterTypes() {
    this.optionPickerList.innerHTML = '';
    const filterTypesEntries = Object.entries(this.currentFilterTypes);
    const filterTypesPrefixes = JSON.parse(this.dataset.filterTypesPrefixes || '{}');
    
    if(filterTypesEntries.length) {
      this.optionPickerBtn.classList.remove('hide');
      filterTypesEntries.forEach(([title, options]) => {
        const typeItem = document.createElement('li');
        typeItem.classList.add('option-picker-list-item');
        
        // Get the prefix for this filter type if it exists
        const prefix = filterTypesPrefixes[title] || '';
        
        typeItem.innerHTML = `
          <p class="option-picker-list-item-title">${title}</p>
          <ul class="option-picker-list-sub">
            ${options.map(option => {
              // Remove the prefix from the option if it exists
              const displayOption = prefix && option.startsWith(prefix) 
                ? option.replace(prefix, '') 
                : option;
              return `
                <li class="option-picker-list-sub-item">
                  <div class="custom-checkbox"></div>
                  <p data-option-tag='${option}'>${displayOption}</p>
                </li>
              `;
            }).join('')}
          </ul>
        `;
        this.optionPickerList.appendChild(typeItem);
      });
    } else {
      this.optionPickerBtn.classList.add('hide');
    }
  }

  filterAndRenderProducts() {
    if (this.dalstrongLoader) {
      this.dalstrongLoader.classList.add('active');
      const logoWrapper = this.dalstrongLoader.querySelector('.animating-logo-wrapper');
      if (logoWrapper) {
        logoWrapper.insertAdjacentHTML('beforeend', `
          <img 
            src="${logoWrapper.dataset.imageSrc}"
            alt="Animated logo loader"
            width="100"
            height="88"
          />
        `);
      }
    }

    const allProducts = JSON.parse(sessionStorage.getItem('allProducts')) || [];
    let filteredProducts = [];
    let filteredCustomCardsData = [];
    if (this.selectedOptions.length === 0) {
      filteredProducts = allProducts.sort((a, b) => {
        if (a.node.availableForSale && !b.node.availableForSale) return -1;
        if (!a.node.availableForSale && b.node.availableForSale) return 1;
        return 0;
      });
      filteredCustomCardsData = this.customCardsData;
      console.log("filteredCustomCardsData: ", filteredCustomCardsData);
    } else {
      const groupedOptions = {};
      this.selectedOptions.forEach(option => {
        Object.entries(this.currentFilterTypes).forEach(([type, options]) => {
          if (options.includes(option)) {
            if (!groupedOptions[type]) {
              groupedOptions[type] = [];
            }
            groupedOptions[type].push(option);
          }
        });
      });
      filteredProducts = allProducts
        .filter(({ node }) => {
          return Object.entries(groupedOptions).every(([type, options]) => {
            return options.some(option => {
              return node.tags.includes(option);
            });
          });
        })
        .sort((a, b) => {
          if (a.node.availableForSale && !b.node.availableForSale) return -1;
          if (!a.node.availableForSale && b.node.availableForSale) return 1;
          return 0;
        });
      // Filter custom cards by tags
      filteredCustomCardsData = this.customCardsData.filter(card => {
        const product = card.fields.find(field => field.key === 'product').reference;
        const tags = product?.tags || [];
        return Object.entries(groupedOptions).every(([type, options]) => {
          return options.some(option => tags.includes(option));
        });
      });
    }
    this.generateCustomCards(filteredCustomCardsData);
    this.filteredProducts = filteredProducts;
    this.currentPage = 1;
    const paginatedProducts = this.filteredProducts.slice(0, this.pageSize);
    this.renderProducts(paginatedProducts, false);
    this.renderPaginationControls(this.filteredProducts.length);
  }
  
  updateSelectedOptions(item) {
    const option = item.querySelector('p').dataset.optionTag;
    if (this.selectedOptions.includes(option)) {
      this.selectedOptions = this.selectedOptions.filter(o => o !== option);
    } else {
      this.selectedOptions.push(option);
    }

    this.filterAndRenderProducts();
  }

  initSwiper() {
    const swiperElement = this.querySelector('.swiper');
    if (!swiperElement) return;

    this.swiper = new Swiper(swiperElement, {
      slidesPerView: 'auto',
      spaceBetween: 30,
      grabCursor: 'true',
      mousewheel: window.innerWidth > 768 ? { forceToAxis: true, sensitivity: 1, releaseOnEdges: true } : false,
      breakpoints: {
        320: {
          spaceBetween: 20
        },
        769: {
          spaceBetween: 30
        }
      }
    });
  }

  renderPaginationControls(totalProducts) {
    let paginationContainer = this.querySelector('.collection-pagination');
    if (!paginationContainer) {
      paginationContainer = document.createElement('div');
      paginationContainer.className = 'collection-pagination';
      this.appendChild(paginationContainer);
    }
    paginationContainer.innerHTML = '';

    const displayedCount = Math.min(this.currentPage * this.pageSize, totalProducts);
    const startIndex = totalProducts > 0 ? 1 : 0;
    const endIndex = displayedCount;
    if (totalProducts === 0) {
      paginationContainer.style.display = 'none';
      return;
    }
    paginationContainer.style.display = '';

    const rangeText = document.createElement('div');
    rangeText.className = 'collection-pagination-range';
    rangeText.textContent = `${startIndex} - ${endIndex} of ${totalProducts} PRODUCTS`;
    paginationContainer.appendChild(rangeText);

    if (endIndex < totalProducts) {
      const loadMoreBtn = document.createElement('button');
      loadMoreBtn.className = 'collection-pagination-load-more';
      loadMoreBtn.textContent = 'LOAD MORE';
      loadMoreBtn.addEventListener('click', () => {
        this.currentPage += 1;
        const start = (this.currentPage - 1) * this.pageSize;
        const end = Math.min(start + this.pageSize, totalProducts);
        const nextProducts = this.filteredProducts.slice(start, end);
        this.renderProducts(nextProducts, true); // append only next page
        this.renderPaginationControls(totalProducts);
      });
      paginationContainer.appendChild(loadMoreBtn);
    }
  }
}

customElements.define('collection-grid-new', CollectionGridNew);